import { Injectable } from '@angular/core';
import { SitesTableObject } from 'src/app/models/orders/order-details-sites/sites-table/sites-object.model';
import { AppService } from 'src/app/app.service';
import { isUndefined } from 'util';
import { SitesObject } from 'src/app/models/orders/order-details-sites/sites-tab-object-model';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrderDetailsSitesContactsConverter } from './specific-order/order-details-sites-contacts.converter';
import { OrderDetailsSitesAddressesConverter } from './specific-order/order-details-sites-addresses.converter';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SitesService {

  appData: any;

  constructor(private contactsConverter: OrderDetailsSitesContactsConverter,
    private addressesConverter: OrderDetailsSitesAddressesConverter,
    private httpClient: HttpClient,
    appService: AppService) {
    this.appData = appService.settings;
  }

  getSiteList(item: ItemObject): Observable<Array<SitesObject>> {
    const type = item.type.equals(OrderTypeObject.PRODUCT) ? 'products' : 'services';
    return this.httpClient.get<any>(`${this.appData.webApi}/${type}/${item.orderId}/sites`)
      .pipe(
        map(sitesJSON => {
          const allSites = new Array<SitesObject>();
          let id = 0;

          if (!isUndefined(sitesJSON)) {
            for (const site of sitesJSON) {
              let newSite = new SitesTableObject(id, site.name, site.roles.toString(), site.contacts.length);
              let contacts = this.contactsConverter.convert(site);
              let addressesWithCorrectFormat = this.addressesConverter.convert(site);
              allSites.push(new SitesObject(newSite, contacts, addressesWithCorrectFormat));
              id++;
            }
          }
          return allSites;
        })
      );
  }
}
